import { API_BASE_URL } from "../config/apiBaseUrl";

const ADMIN_BASE = "/api/admin/automotive";
const PORTAL_BASE = "/api/v1/automap/dealer-portal";

function authHeaders() {
  return { credentials: "include" };
}

function qs(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") search.set(key, value);
  });
  const query = search.toString();
  return query ? `?${query}` : "";
}

export async function fetchCampaignsHub() {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/campaigns`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar campañas.");
  return res.json();
}

export async function fetchLaunchDashboard(range = "last_7_days") {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/campaigns/launch${qs({ range })}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar launch dashboard.");
  return res.json();
}

export async function fetchLaunchReadiness() {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/campaigns/launch/readiness`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar readiness.");
  return res.json();
}

export async function fetchDailyMonitor(date) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/campaigns/launch/daily-monitor${qs({ date })}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar daily monitor.");
  return res.json();
}

export async function fetchLaunchLeads(params = {}) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/campaigns/launch/leads${qs(params)}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar leads de launch.");
  return res.json();
}

export async function fetchCampaignAssets() {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/campaigns/launch/assets`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar assets.");
  return res.json();
}

export async function buildCampaignUrl(payload) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/campaigns/build-url`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("No se pudo construir URL.");
  return res.json();
}

export async function saveLaunchDailyNote(payload) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/campaigns/launch/daily-notes`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("No se pudo guardar nota.");
  return res.json();
}

export async function completeLaunchDailyReview(date) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/campaigns/launch/daily-review`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ date }),
  });
  if (!res.ok) throw new Error("No se pudo marcar revisión.");
  return res.json();
}

export async function resolveLaunchAlert(alertId) {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/campaigns/launch/alerts/${alertId}/resolve`, {
    method: "PATCH",
    credentials: "include",
  });
  if (!res.ok) throw new Error("No se pudo resolver alerta.");
  return res.json();
}

export async function fetchDealerLaunchSummary(dealerId, range = "last_7_days") {
  const res = await fetch(
    `${API_BASE_URL}${PORTAL_BASE}/dealers/${dealerId}/launch-summary${qs({ range })}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar resumen launch.");
  return res.json();
}
